import React from 'react';
import TemplateFlowManager from "../TemplateFlow/TemplateFlowManager";
import Authorized from "../../../layouts/Authorized";
import { Box } from "@mui/material";
import { ThemeContext } from "styled-components";
import { useContext } from 'react';

const ViewNewTemplate = React.memo(() => {
    const theme = useContext(ThemeContext);

    return(
        <>
            <Authorized>
                <Box sx={{
                    backgroundColor: theme.colors.backgroundSecondary,
                    width: '100%',
                    height: '100vh',
                    maxHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingTop: '72px',
                    paddingBottom: '50px',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                }}>
                    <Box
                        sx={{
                            position: 'relative',
                            width: 500,
                            maxWidth: '100%',
                            flex: 1,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: 20,
                            borderRadius: 4,
                            color: theme.colors.text,
                            backgroundColor: theme.colors.backgroundPrimary,
                            padding: 3,
                            paddingTop: 0,
                            overflow: 'hidden',
                        }}
                    >
                        <TemplateFlowManager />
                    </Box>
                </Box>
            </Authorized>
        </>
    )
});

export default ViewNewTemplate;
